import { ProductGroupModel, ProductModel } from '../../../model/product.model';
import { F7ComponentContext, F7Page } from '../../../types/framework7-types';
import { Router } from 'framework7/build/core/modules/router/router';
import { BaseComponent, ComponentState } from '../../../lib/base-component';
import { RootServices } from '../../../services/root.services';
import { ChatRoom } from '../../../lib/nam-chat/chat-room';
import { CommonService } from '../../../services/common.service';
import { TaskReminderModel } from '../../../model/task.model';
import { BehaviorSubject } from 'rxjs';
import { Chart, registerables } from 'chart.js';
import { AccMasterBookModel } from '../../../../../src/app/model/accounting.model';
import { SmartSelect } from 'framework7/build/core/components/smart-select/smart-select'
import { Calendar } from 'framework7/build/core/components/calendar/calendar'
import { Dialog } from 'framework7/build/core/components/dialog/dialog'
import { Popup } from 'framework7/build/core/components/popup/popup'
import { Autocomplete } from 'framework7/build/core/components/autocomplete/autocomplete'
import { ContactModel } from '../../../../../src/app/model/contact.model';
// import * as $ from 'jquery';
declare const $: any;

// declare const $: any;
export interface ComponentStateExtend extends ComponentState {
  // [key: string]: any;
  instance: F7ComponentContextExtend,
  // voucher?: CommercePosOrderModel;
  // vouchers?: CommercePosOrderModel[];
  reportForm?: {
    ReportType?: SmartSelect.SmartSelect,
    Range?: Calendar.Calendar,
    Employees?: Autocomplete.Autocomplete,
    Objects?: Autocomplete.Autocomplete,
    Products?: Autocomplete.Autocomplete,
    ProductGroups?: SmartSelect.SmartSelect,
    ProductCategories?: SmartSelect.SmartSelect,
    Branches?: SmartSelect.SmartSelect,
  },
  reportTypeList?: { id: string, text: string, reportType?: string, range: Date[] }[],
  reportType?: string,
  reportFormDialog?: Dialog.Dialog;
  reportFormPopup?: Popup.Popup;
}

export class F7ComponentContextExtend extends F7ComponentContext {
  // messagebar?: F7Messagebar;
  // messages?: Messages.Messages;
  // images?: string[];
  responseInProgress?: boolean;
  // answers?: string[];
  // people?: { name?: string, avatar?: string }[];
  // hideToolbar?: () => void;
  // sheetToggle?: () => void;
  // deleteAttachment?: (e: MouseEvent, index: number) => void;
  // handleAttachment?: (e: MouseEvent) => void;
  // checkAttachments?: () => void;
  // sendMessage?: () => void;

  detailDialog?: Dialog.Dialog;

  $root: any;
  $route: Router.Route & { context?: { backTitle?: string, title?: string, largeTitle?: string, reminder?: TaskReminderModel, chatRoom?: ChatRoom, reminderList$?: BehaviorSubject<TaskReminderModel[]> } };
}

/** Component group manager */
export class SalesDashboardComponent extends BaseComponent<ComponentStateExtend> {
  // states: { [key: string]: State } = {};

  title: 'Sales Dashboard'
  stateMap = {
    NOTJUSTAPPROVED: {
      label: 'Chưa duyệt',
      status: 'warning',
    },
    APPROVED: {
      label: 'Đã duyệt',
      status: 'success',
    },
  };

  masterBook: AccMasterBookModel = null;
  costAndRevenueStatisticsData: {};
  reportDate = new Date();

  dateReportList = [
    { id: 'DAY', text: 'Phân tích theo ngày', range: [new Date(new Date().getFullYear(), new Date().getMonth(), 1, 0, 0, 0), new Date(new Date().getFullYear(), new Date().getMonth(), 31, 23, 59, 59)] },
    { id: 'MONTH', text: 'Phân tích theo tháng', range: [new Date(new Date().getFullYear(), 0, 1), new Date(new Date().getFullYear(), 11, 31)] },
    { id: 'DAYOFWEEK', text: 'Phân tích theo tuần', range: [this.getUpcomingMonday(), this.getUpcomingSunday()] },
    { id: 'HOUR', text: 'Phân tích theo giờ', range: [new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 0, 0, 0), new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 23, 59, 59)] },
  ];

  constructor(
    public rootServices: RootServices,
    public commonService: CommonService,
  ) {
    super(rootServices);
    // // console.log('Click here to open ts file');
    Chart.register(...registerables);
  }

  getUpcomingMonday() {
    const date = new Date();
    const today = date.getDate();
    const dayOfTheWeek = date.getDay();
    const newDate = date.setDate(today - dayOfTheWeek + 1);
    const result = new Date(newDate);
    result.setHours(0);
    result.setMinutes(0);
    result.setSeconds(0);
    return result;
  }
  getUpcomingSunday() {
    const date = new Date();
    const today = date.getDate();
    const dayOfTheWeek = date.getDay();
    const newDate = date.setDate(today - dayOfTheWeek + 7);
    const result = new Date(newDate);
    result.setHours(23);
    result.setMinutes(59);
    result.setSeconds(59);
    return result;
  }

  onF7pageRemove(chatRoomId: string) {
    // if (this.chatRoomCacheList[chatRoomId]) {
    //   this.chatRoomCacheList[chatRoomId].disconnect();
    // }
  }

  prepareItem(p: ProductModel) {
    p.DateOfOrderText = this.rootServices.datePipe.transform(p.DateOfOrder, 'short');
    p.StateLabel = this.stateMap[p.State]?.label || 'Unknow';
    p.StateStatus = this.stateMap[p.State]?.status || 'primary';
    return p;
  }

  async getList(params: any) {
    // console.log(self.searchBar);
    // return this.rootServices.apiService.getPromise<any[]>('/purchase/order-vouchers', {
    //   includeCreator: true,
    //   includeRelativeVouchers: true,
    //   sort_Id: 'desc',
    //   limit: 10,
    //   offset: 0,
    //   ...params,
    // });
    return [];
  }

  dayOfWeekMap = {
    1: 'cn',
    2: 't2',
    3: 't3',
    4: 't4',
    5: 't5',
    6: 't6',
    7: 't7',
  };
  makeStaticLabel(item: any, reportType: string) {
    if (reportType === 'MONTH') {
      return (item['Month']).toString().padStart(2, "0") + '/' + (item['Year']).toString().padStart(2, "0");
    }
    if (reportType === 'DAY') {
      return (item['Day']).toString().padStart(2, "0") + '/' + (item['Month']).toString().padStart(2, "0");
    }
    if (reportType === 'HOUR') {
      return (item['Hour']).toString().padStart(2, "0");
    }
    // return (item['DayOfWeek']).toString().padStart(2, "0");
    return this.dayOfWeekMap[item['DayOfWeek']];
  }

  makeTimeline(item: any, reportType: string) {
    if (reportType === 'MONTH') {
      return (item['Year']).toString().padStart(2, "0") + '/' + (item['Month']).toString().padStart(2, "0");
    }
    if (reportType === 'DAY') {
      return item['Year'] + '/' + (item['Month']).toString().padStart(2, "0") + '/' + (item['Day']).toString().padStart(2, "0");
    }
    if (reportType === 'HOUR') {
      return item['Year'] + '/' + (item['Month']).toString().padStart(2, "0") + '/' + (item['Day']).toString().padStart(2, "0") + '/' + (item['Hour']).toString().padStart(2, "0");
    }
    return item['Year'] + '/' + (item['Month']).toString().padStart(2, "0") + '/' + (item['Day']).toString().padStart(2, "0");
  }

  // On component init
  async onComponentInit(state: ComponentStateExtend, index: string, asCase?: string, f7Page?: F7Page) {
    try {
      const currentState = await super.onComponentInit(state, index, asCase, f7Page);
      currentState.reportType = 'HOUR';
      currentState.reportForm = {};
      // const ctx = $('#myChart');

      // Load statistic data for sales activity
      await this.rootServices.apiService.getPromise<AccMasterBookModel[]>('/accounting/master-books/current', {}).then(rs => {
        this.masterBook = rs[0];
        const current = new Date();
        const previousMonth = new Date(current.getTime() - 31 * 24 * 60 * 60 * 1000);
        let previousYear = new Date();
        previousYear.setFullYear(previousYear.getFullYear() - 1);
        let fromDate = new Date(this.masterBook.DateOfBeginning);
        currentState.reportTypeList = [
          { id: 'DAY', reportType: 'DAY', text: '30 ngày gần nhất', range: [new Date(previousMonth.getFullYear(), previousMonth.getMonth(), previousMonth.getDate(), 0, 0, 0), current] },
          { id: 'MONTH', reportType: 'MONTH', text: '12 tháng gần nhất', range: [new Date(previousYear.getFullYear(), previousYear.getMonth(), previousYear.getDate()), current] },
          { id: 'FROMOPENED', reportType: 'MONTH', text: 'Đầu kỳ đến hiện tại', range: [new Date(fromDate.getFullYear(), fromDate.getMonth(), fromDate.getDate()), current] },
          { id: 'DAYOFWEEK', reportType: 'DAYOFWEEK', text: 'Các ngày trong tuần', range: [this.getUpcomingMonday(), this.getUpcomingSunday()] },
          { id: 'HOUR', reportType: 'HOUR', text: '24 giờ trong ngày', range: [new Date(current.getFullYear(), current.getMonth(), current.getDate(), 0, 0, 0), new Date(current.getFullYear(), current.getMonth(), current.getDate(), 23, 59, 59)] },
        ];
      });

      await this.rootServices.apiService.getPromise<ProductGroupModel[]>('/branch/branches', { onlyIdText: true, limit: 'nolimit' }).then(rs => {
        currentState.instance.branchList = rs;
      });
      await this.rootServices.apiService.getPromise<ProductGroupModel[]>('/admin-product/groups', { onlyIdText: true, limit: 'nolimit' }).then(rs => {
        currentState.instance.productGroupList = rs;
      });
      await this.rootServices.apiService.getPromise<ProductGroupModel[]>('/admin-product/categories', { onlyIdText: true, limit: 'nolimit' }).then(rs => {
        currentState.instance.productCategoryList = rs;
      });
      currentState.instance.$setState({
        branchList: currentState.instance.branchList,
        reportTypeList: currentState.reportTypeList,
        productGroupList: currentState.instance.productGroupList,
        productCategoryList: currentState.instance.productCategoryList,
      });

      // Map report query form
      currentState.reportForm.Branches = currentState.instance.$f7.smartSelect.get($(f7Page.el).find('[name="Branches"]').closest('.smart-select') as any);
      currentState.reportForm.ReportType = currentState.instance.$f7.smartSelect.get($(f7Page.el).find('[name="ReportType"]').closest('.smart-select') as any);
      currentState.reportForm.Range = currentState.instance.$f7.calendar.create({
        inputEl: '[name="ReportRange"]',
        dateFormat: 'd/m/yyyy',
        rangePicker: true,
        closeOnSelect: true,
        on: {
          change(calendar, value: Date[]) {
            console.log(calendar, value);
            if (value && value.length == 2) {
              currentState.instance.refresh();
            }
          },
        }
      });
      // currentState.reportForm.Employees = currentState.instance.$f7.smartSelect.get($(f7Page.el).find('[name="Employees"]').closest('.smart-select'));
      currentState.reportForm.Employees = this.createAutocompleteField($(f7Page.el).find('.autocomplete.Employees')[0], currentState, (query) => {
        return this.rootServices.apiService.getPromise<ContactModel[]>('/contact/contacts', { search: query, includeIdText: true, includeGroups: true, isn_User: null }).then(results => {
          return results.map(m => {
            m.id = m.User;
            m.text = `${m.Name}${m.Groups ? ' (' + m.Groups.map(g => this.commonService.getObjectText(g as any)).join(', ') + ')' : ''}`;
            return m;
          });
        });
      }, (value) => {
        currentState.instance.$setState({
          Employees: value.map(m => this.commonService.getObjectId(m)),
          EmployeesText: value.map(m => this.commonService.getObjectText(m)).join(', '),
        });
      }, (value) => {
        currentState.instance.refresh();
      }, { multiple: true });
      // currentState.reportForm.Objects = currentState.instance.$f7.smartSelect.get($(f7Page.el).find('[name="Objects"]').closest('.smart-select'));
      currentState.reportForm.Objects = this.createAutocompleteField($(f7Page.el).find('.autocomplete.Objects')[0], currentState, (query) => {
        return this.rootServices.apiService.getPromise<ContactModel[]>('/contact/contacts', { search: query, includeIdText: true, includeGroups: true }).then(results => {
          return results.map(m => {
            m.text = `${m.Name}${m.Groups ? ' (' + m.Groups.map(g => this.commonService.getObjectText(g as any)).join(', ') + ')' : ''}`;
            return m;
          });
        });
      }, (value) => {
        currentState.instance.$setState({
          Objects: value.map(m => this.commonService.getObjectId(m)),
          ObjectsText: value.map(m => this.commonService.getObjectText(m)).join(', '),
        });
      }, (value) => {
        currentState.instance.refresh();
      }, { multiple: true });
      currentState.reportForm.ProductGroups = currentState.instance.$f7.smartSelect.get($(f7Page.el).find('[name="ProductGroups"]').closest('.smart-select') as any);
      currentState.reportForm.ProductCategories = currentState.instance.$f7.smartSelect.get($(f7Page.el).find('[name="ProductCategories"]').closest('.smart-select') as any);
      // currentState.reportForm.Products = currentState.instance.$f7.smartSelect.get($(f7Page.el).find('[name="Products"]').closest('.smart-select'));
      currentState.reportForm.Products = this.createAutocompleteField($(f7Page.el).find('.autocomplete.Products')[0], currentState, (query) => {
        return this.rootServices.apiService.getPromise<ContactModel[]>('/admin-product/products', { search: query, includeIdText: true, limit: 100 });
      }, (value) => {
        currentState.instance.$setState({
          Products: value.map(m => this.commonService.getObjectId(m)),
          ProductsText: value.map(m => this.commonService.getObjectText(m)).join(', '),
        });
      }, (value) => {
        currentState.instance.refresh();
      }, { multiple: true });
      // End

      currentState.reportForm.Branches.on('close' as any, (smartSelect, value) => {
        console.log(smartSelect, value);
        currentState.instance.refresh();
      });
      currentState.reportForm.ReportType.on('change' as any, (smartSelect, value) => {
        console.log(smartSelect, value);
        const range = currentState.reportTypeList.find(f => f.id == value)?.range;
        currentState.reportForm.Range.setValue(range);
        // currentState.instance.refresh();
      });
      currentState.reportForm.ProductGroups.on('close' as any, (smartSelect, value) => {
        console.log(smartSelect, value);
        currentState.instance.refresh();
      });
      currentState.reportForm.ProductCategories.on('close' as any, (smartSelect, value) => {
        console.log(smartSelect, value);
        currentState.instance.refresh();
      });

      // prepare for report form dialog
      // currentState.reportFormDialog = currentState.instance.$app.dialog.create({
      //   el: f7Page.$el.find('.dialog-report-form'),
      //   closeByBackdropClick: true,
      // });
      // currentState.reportFormPopup = currentState.instance.$app.popup.create({
      //   el: f7Page.$el.find('.popup-report-form'),
      //   backdrop: true,
      //   swipeToClose: true,
      //   // closeByBackdropClick: true,
      //   on: {
      //     close: () => {
      //       currentState.instance.refresh();
      //     }
      //   }
      // });

      setTimeout(() => {
        currentState.reportForm.ReportType.setValue(currentState.reportType);
        // currentState.reportForm.range.setValue(currentState.reportForm.range.getValue());
        currentState.instance.refresh();
      }, 300);
      return currentState;
    } catch (err) {
      this.commonService.showError(err);
    }
  }

  resetReportForm() {
    const currentState = this.currentState;
    currentState.reportForm.ReportType.setValue('HOUR');
    currentState.reportForm.ProductGroups.setValue([]);
    currentState.reportForm.Branches.setValue([]);
    currentState.reportForm.Branches.setValue([]);

    currentState.reportForm.Objects.value = []
    currentState.reportForm.Employees.value = []
    currentState.reportForm.Products.value = []

    currentState.instance.$setState({
      Objects: [],
      ObjectsText: '',
      Employees: [],
      EmployeesText: '',
      Products: [],
      ProductsText: ''
    });

    currentState.instance.refresh();
  }

  get f7Component(): Router.RouteParameters {
    const $this = this;
    return {
      name: 'sales-dashboard',
      path: '/sales/dashboard',
      component: {
        template: /*html*/`
            <div class="page sales-dashboard" data-name="sales-dashboard">
              <div class="navbar">
                <div class="navbar-bg"></div>
                <div class="navbar-inner sliding">
                  <div class="left">
                    <a class="link back {{textColorClass}}">
                      <i class="icon icon-back"></i>
                      <span class="{{textColorClass}}">{{js "this.backTitle || 'Back'"}}</span>
                    </a>
                  </div>
                  <div class="title">Sales Dashboard</div>
                  <div class="right">
                    <a class="link icon-only">
                      <i class="icon f7-icons">ellipsis</i>
                    </a>
                  </div>
                </div>
                  <!-- Searchbar is a direct child of "navbar-inner" -->
                <form class="searchbar inventory-adjust-note-list-searchbar searchbar-expandable">
                  <div class="searchbar-inner">
                    <div class="searchbar-input-wrap">
                      <input type="search" placeholder="Search" />
                      <i class="searchbar-icon"></i><span class="input-clear-button"></span>
                      
                    </div>
                    <span class="searchbar-disable-button {{textColorClass}}">Hủy</span>
                  </div>
                </form>
              </div>
              <div class="page-content ptr-content" @ptr:refresh="refresh" data-ptr-distance="80">
                <div class="ptr-preloader">
                  <div class="preloader"></div>
                  <div class="ptr-arrow"></div>
                </div>
                <div class="searchbar-backdrop product-list-backdrop"></div>

                <div class="block" style="margin-top: 1rem; margin-buttom: 0.3rem">
                  <div class="row">
                    <div class="col-50">
                      <div class="card" style="">
                        <div class="card-content card-content-padding" style="color: var(--ion-color-primary);">
                          <div class="card-content-wrap">
                            <div class="icon-wrap">
                              <button class="col button button-large button-fill color-blue">
                                <i class="icon f7-icons">chart_bar_circle</i>
                              </button>
                            </div>
                            <div class="label-wrap">
                              <div class="label-text">Doanh thu</div>
                              <div class="label-value" style="margin-top: -3px;">DT: {{summaryReportData.Revenues}}</div>
                              <div class="label-value" style="margin-top: -3px;">GV: {{summaryReportData.CostOfGoodsSold}}</div>
                              <div class="label-value" style="margin-top: -3px;">LK: {{summaryReportData.NumOfVouchers}}</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-50">
                      <div class="card" style="">
                        <div class="card-content card-content-padding" style="color: var(--ion-color-warning);">
                          <div class="card-content-wrap">
                            <div class="icon-wrap">
                              <button class="col button button-large button-fill color-orange">
                                <i class="icon f7-icons">arrow_down_right_circle</i>
                              </button>
                            </div>
                            <div class="label-wrap">
                              <div class="label-text">Giảm DT</div>
                              <div class="label-value" style="margin-top: -3px;">TH: {{summaryReportData.DecreaseRevenuesByReturns}}</div>
                              <div class="label-value" style="margin-top: -3px;">GG: {{summaryReportData.DecreaseRevenuesByDiscount}}</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-50">
                      <div class="card" style="">
                        <div class="card-content card-content-padding" style="color: var(--ion-color-success);">
                          <div class="card-content-wrap">
                            <div class="icon-wrap">
                              <button class="col button button-large button-fill color-green">
                                <i class="icon f7-icons">graph_circle</i>
                              </button>
                            </div>
                            <div class="label-wrap">
                              <div class="label-text">Lãi gộp</div>
                              <div class="label-value">{{summaryReportData.GrossProfit}}</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-50">
                      <div class="card" style="">
                        <div class="card-content card-content-padding" style="color: var(--ion-color-danger);">
                          <div class="card-content-wrap">
                            <div class="icon-wrap">
                              <button class="col button button-large button-fill color-red">
                                <i class="icon f7-icons">creditcard</i>
                              </button>
                            </div>
                            <div class="label-wrap">
                              <div class="label-text">Công nợ</div>
                              <div class="label-value">{{summaryReportData.CustomerReceivableDebt}}</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!--<div class="block" style="overflow: hidden">
                  <div class="row">
                    <button class="col button button-fill color-orange" @click="openReportFormDialog">Cài đặt báo cáo</button>
                    <button class="col button button-fill color-red" @click="resetReportForm">Đặt lại</button>
                  </div>
                </div>-->
                <div class="block-title" style="margin-top: 0.5rem">Bộ lọc</div>
                <div class="block block-strong inset" style="padding: 0; overflow: hidden">
                  <div class="list accordion-list inline-labels no-hairlines" style="margin: 0;">
                    <ul>
                      <li>
                        <a class="item-link smart-select smart-select-init" data-open-in="sheet" data-close-on-select="true">
                            <select name="ReportType">
                              {{#each reportTypeList}}
                              <option value="{{id}}">{{text}}</option>
                              {{/each}}
                            </select>
                            <div class="item-content">
                              <div class="item-inner">
                                <div class="item-title">Báo cáo theo</div>
                              </div>
                            </div>
                          </a>
                      </li>
                      <li>
                        <div class="item-content item-input">
                          <div class="item-inner">
                            <div class="item-title item-label">Phạm vi</div>
                            <div class="item-input-wrap">
                              <input name="ReportRange" type="text" placeholder="Ngày báo cáo" readonly="readonly" id="reportDate" @change="onReportDateChange" style="text-align: right;"/>
                            </div>
                          </div>
                        </div>
                      </li>
                      <li class="accordion-item">
                        <a class="item-content item-link">
                          <div class="item-inner">
                            <div class="item-title" style="font-weight: normal" >Nâng cao</div>
                            <div class="item-after"><span class="badge">xổ xuống</span></div>
                          </div>
                        </a>
                        <div class="accordion-item-content">
                          <div class="list inline-labels no-hairlines" style="margin: 0;">
                            <ul>
                              <li>
                                <a class="item-link smart-select smart-select-init" data-open-in="sheet" data-close-on-select="true">
                                    <select name="Branches" multiple>
                                      {{#each branchList}}
                                      <option value="{{id}}">{{text}}</option>
                                      {{/each}}
                                    </select>
                                    <div class="item-content">
                                      <div class="item-inner">
                                        <div class="item-title">Chi nhánh</div>
                                      </div>
                                    </div>
                                  </a>
                              </li>
                              <li class="autocomplete Employees">
                                <div class="item-link smart-select item-content" href="#">
                                  <div class="item-inner" style="display: flex;">
                                    <div class="item-title">Nhân viên</div>
                                    <div class="item-after text-color-red">{{text EmployeesText coalesce="Chọn..."}}</div>
                                  </div>
                                </div>
                              </li>
                              <li class="autocomplete Objects">
                                <div class="item-link smart-select item-content" href="#">
                                  <div class="item-inner" style="display: flex;">
                                    <div class="item-title">Khách hàng</div>
                                    <div class="item-after text-color-red">{{text ObjectsText coalesce="Chọn..."}}</div>
                                  </div>
                                </div>
                              </li>
                              <li>
                                <a class="item-link smart-select smart-select-init" data-open-in="sheet" data-close-on-select="true">
                                    <select name="ProductGroups" multiple>
                                      {{#each productGroupList}}
                                      <option value="{{id}}">{{text}}</option>
                                      {{/each}}
                                    </select>
                                    <div class="item-content">
                                      <div class="item-inner">
                                        <div class="item-title">Nhóm sản phẩm</div>
                                      </div>
                                    </div>
                                  </a>
                              </li>
                              <li>
                                <a class="item-link smart-select smart-select-init" data-open-in="sheet" data-close-on-select="true">
                                    <select name="ProductCategories" multiple>
                                      {{#each productCategoryList}}
                                      <option value="{{id}}">{{text}}</option>
                                      {{/each}}
                                    </select>
                                    <div class="item-content">
                                      <div class="item-inner">
                                        <div class="item-title">Danh mục sản phẩm</div>
                                      </div>
                                    </div>
                                  </a>
                              </li>
                              <li class="autocomplete Products">
                                <div class="item-link smart-select item-content" href="#">
                                  <div class="item-inner" style="display: flex;">
                                    <div class="item-title">Sản phẩm</div>
                                    <div class="item-after text-color-red">{{text ProductsText coalesce="Chọn..."}}</div>
                                  </div>
                                </div>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>

                <div class="tabs-swipeable-wrap" style="height: initial;">
                  <div class="tabs">
                    <div id="sales-chart-tab-1" class="page-content tab tab-active" style="padding-top: 0px; padding-bottom: 0">
                      <div class="block-title" style="margin-top: 0.5rem">Danh thu/giá vốn<a class="button button-small button-fill tab-link" href="#sales-chart-tab-2" style="float: right; font-size: 0.7rem; font-weight: bold">next»</a></div>
                      <div class="block block-strong inset" style="margin-bottom: 0;">
                        <canvas id="salesActivityChart" width="300" height="200"></canvas>
                      </div>
                    </div>
                    <div id="sales-chart-tab-2" class="page-content tab" style="padding-top: 0px; padding-bottom: 0">
                      <div class="block-title" style="margin-top: 0.5rem">Lượt khách<a class="button button-small button-fill tab-link" href="#sales-chart-tab-3" style="float: right; font-size: 0.7rem; font-weight: bold">next»</a></div>
                      <div class="block block-strong inset" style="margin-bottom: 0;">
                        <canvas id="salesNumOfVouchersChart" width="300" height="200"></canvas>
                      </div>
                    </div>
                    <div id="sales-chart-tab-3" class="page-content tab" style="padding-top: 0px; padding-bottom: 0">
                      <div class="block-title" style="margin-top: 0.5rem">Công nợ</div>
                      <div class="block block-strong inset" style="margin-bottom: 0;">
                        <canvas id="salesDebtChart" width="300" height="200"></canvas>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="block block inset" style="padding: 0rem; overflow: hidden; margin-bottom: 0">
                </div>
                <div class="tabs-swipeable-wrap" style="height: initial;">
                  <div class="tabs">
                    <div id="sales-top-tab-1" class="page-content tab tab-active" style="padding-top: 0px">
                      <div class="block-title">Top nhân viên theo doanh số<a class="button button-small button-fill tab-link" href="#sales-top-tab-2" style="float: right; font-size: 0.7rem; font-weight: bold">next»</a></div>
                      <div class="list media-list inset">
                        <ul>
                          {{#each topEmployeeList}}
                          <li data-name="remove-chat-room-member" data-id="{{Employee}}" @click="gotoProfile">
                            <a class="item-content item-link">
                              <div class="item-media">
                                {{#js_if "this.EmployeeAvatar"}}
                                <div class="list-item-img" style="width: 44px; height: 44px; background-image: url({{js "this.EmployeeAvatar &&  this.EmployeeAvatar.SmallImage"}});"></div>
                                {{else}}
                                <div class="list-item-img" style="width: 44px; height: 44px">
                                  <i style="font-size: 16px" class="f7-icons">person_fill</i>
                                </div>
                                {{/js_if}}
                              </div>
                              <div class="item-inner">
                                <div class="item-title-row">
                                  <div class="item-title">{{EmployeeName}}</div>
                                  <div class="item-after">{{#if RefIcon}}<img style="height: 12px;" src="{{RefIcon}}">{{/if}}</div>
                                </div>
                                <div class="item-subtitle" style="color: var(--ion-color-primary)">{{Revenus}}/{{GenerateNumOfVouchers}} đơn</div>
                              </div>
                            </a>
                          </li>
                          {{/each}}
                        </ul>
                      </div>
                    </div>  
                    <div id="sales-top-tab-2" class="page-content tab" style="padding-top: 0px">
                      <div class="block-title">Top khách theo doanh số<a class="button button-small button-fill tab-link" href="#sales-top-tab-3" style="float: right; font-size: 0.7rem; font-weight: bold">next»</a></div>
                      <div class="list media-list inset">
                        <ul>
                          {{#each topCustomerList}}
                          <li data-name="remove-chat-room-member" data-id="{{Employee}}" @click="gotoProfile">
                            <a class="item-content item-link">
                              <div class="item-media">
                                {{#js_if "this.Avatar"}}
                                <div class="list-item-img" style="width: 44px; height: 44px; background-image: url({{js "this.EmployeeAvatar &&  this.Avatar.SmallImage"}});"></div>
                                {{else}}
                                <div class="list-item-img" style="width: 44px; height: 44px">
                                  <i style="font-size: 16px" class="f7-icons">person_fill</i>
                                </div>
                                {{/js_if}}
                              </div>
                              <div class="item-inner">
                                <div class="item-title-row">
                                  <div class="item-title">{{ObjectName}}</div>
                                  <div class="item-after">{{#if RefIcon}}<img style="height: 12px;" src="{{RefIcon}}">{{/if}}</div>
                                </div>
                                <div class="item-subtitle" style="color: var(--ion-color-primary)">{{Revenus}}/{{GenerateNumOfVouchers}} đơn</div>
                              </div>
                            </a>
                          </li>
                          {{/each}}
                        </ul>
                      </div>
                    </div>  
                    <div id="sales-top-tab-3" class="page-content tab" style="padding-top: 0px">
                      <div class="block-title">Top hàng hóa theo doanh số</div>
                      <div class="list media-list inset">
                        <ul>
                          {{#each topGoodsList}}
                          <li data-name="remove-chat-room-member" data-id="{{Employee}}" @click="gotoProfile">
                            <a class="item-content item-link">
                              <div class="item-media">
                                {{#js_if "this.Thumbnail"}}
                                <div class="list-item-img" style="width: 44px; height: 44px; background-image: url({{js "this.Thumbnail &&  this.Thumbnail.SmallImage"}});"></div>
                                {{else}}
                                <div class="list-item-img" style="width: 44px; height: 44px">
                                  <i style="font-size: 16px" class="f7-icons">person_fill</i>
                                </div>
                                {{/js_if}}
                              </div>
                              <div class="item-inner">
                                <div class="item-title-row">
                                  <div class="item-title">{{Description}}</div>
                                  <div class="item-after">{{#if RefIcon}}<img style="height: 12px;" src="{{RefIcon}}">{{/if}}</div>
                                </div>
                                <div class="item-subtitle" style="color: var(--ion-color-primary)">{{Revenus}}/{{GenerateNumOfVouchers}} đơn</div>
                              </div>
                            </a>
                          </li>
                          {{/each}}
                        </ul>
                      </div>
                    </div>  
                  </div>
                </div>
              
              </div>

              <div class="popup popup-report-form">
                <div class="view">
                  <div class="page">
                    <div class="navbar">
                      <div class="navbar-bg"></div>
                      <div class="navbar-inner">
                        <div class="title">Cài đặt báo cáo</div>
                        <div class="right">
                          <!-- Link to close popup -->
                          <a class="link popup-close">Close</a>
                        </div>
                      </div>
                    </div>
                    <div class="page-content">
                      <div class="list inline-labels no-hairlines" style="margin: 0;">
                        <ul>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                
              </div>

            </div>
        `,
        style: /*css*/`
          .warehouse-container-list .find-order {
            font-size: 16px;
            font-weight: bold;
          }
          .warehouse-container-list .action-bar {
            color: var(--f7-block-strong-text-color);
            padding-top: var(--f7-block-padding-vertical);
            padding-bottom: var(--f7-block-padding-vertical);
            background-color: var(--f7-block-strong-bg-color);
          }

          .page.sales-dashboard .card {
            margin-left: 0; 
            margin-right: 0
          }
          .page.sales-dashboard .card .card-content {
            padding: 0.5rem;
          }
          .page.sales-dashboard .card .card-content-wrap {
            display: flex; flex-direction: row
          }
          .page.sales-dashboard .card .icon-wrap {
            padding-right: 0.5rem;
          }
          .page.sales-dashboard .card .icon-wrap button {
            width: 3rem; height: 3rem
          }
          .page.sales-dashboard .card .label-wrap {

          }
          .page.sales-dashboard .card .label-wrap {
            display: flex; flex-direction: column
          }
          .page.sales-dashboard .card .label-wrap .label-text {
            font-weight: bold; font-size: 1rem
          }
          .page.sales-dashboard .card .label-wrap .label-value {
            font-weight: bold;
            font-size: 0.6rem;
            white-space: nowrap;
          }
          .page.sales-dashboard .show-more-filter {
            display: block;
          }
          .page.sales-dashboard .hide-more-filter {
            display: none;
          }

        `,
        data() {
          return {
            title: $this.title,
            // reminder: {
            //   No: '234234',
            // },
            priceReport: { Details: [] },
            summaryReportData: {

            },
            reportDate: $this.reportDate.getDate() + '/' + ($this.reportDate.getMonth() + 1) + '/' + $this.reportDate.getFullYear(),
            dateReportList: [],
            productGroupList: [],
            moreFilter: false
          };
        },
        methods: {
          toggleShowMoreFilter() {
            const self: F7ComponentContextExtend = this;
            const currentState = $this.state['main'];

            self.$setState({
              moreFilter: !self.moreFilter,
            });

          },
          resetReportForm(e) {
            const self: F7ComponentContextExtend = this;
            const currentState = $this.state['main'];
            $this.resetReportForm();
          },
          // openReportFormDialog(e) {
          //   const self: F7ComponentContextExtend = this;
          //   const currentState = $this.state['main'];
          //   currentState.reportFormPopup.open();
          // },
          // closeReportFormDialog(e) {
          //   const self: F7ComponentContextExtend = this;
          //   const currentState = $this.state['main'];
          //   currentState.reportFormPopup.close();
          // },
          onReportDateChange(e) {
            // const self: F7ComponentContextExtend = this;
            // console.log(e.currentTarget.value);
            // const inputDate = e.currentTarget.value.split('/');
            // $this.reportDate = new Date(inputDate[2], inputDate[1] - 1, inputDate[0]);
            // $this.commonService.showPreloader();
            // self.refresh().then(rs => {
            //   $this.commonService.hidePreloader();
            // }).catch(err => {
            //   $this.commonService.hidePreloader();
            // });
          },
          gotoProfile(e) {
          },
          // Price report
          openVoucher(e, id?: string) {
            const self: F7ComponentContextExtend = this;
            id = id || self.$(e.target).closest('li').data('id') || 'new';

            // if ($this.commonService.frameSocket.isFrameMode && id && id !== 'new') {
            //   $this.commonService.frameSocket.emit('request-open-voucher', { id: id, type: 'PRICEREPORT' });
            // } else {
            $this.rootServices.navigate('/purchase/order/' + id, {
              context: {
                backTitle: $this.title,
                textColorClass: self.textColorClass,
                // memberInfo: $this.currentState.chatRoom.memberList$.getValue().find(f => f.id === id),
                // chatRoom: self.$route.context.chatRoom,
                // reminderList$: self.reminderList$,
              }
            });
            // }
          },
          goto(e) {
            const self: F7ComponentContextExtend = this;
            const url = self.$(e.target).closest('.goto').data('url');
            $this.rootServices.navigate(url);
          },
          chooseOne(e) {
            const self: F7ComponentContextExtend = this;
            const id = self.$(e.target).closest('li').data('id');
            self.$route.context['onChoose'] && self.$route.context['onChoose'](self.productList.find(f => f.Code === id));
          },
          chooseProduct(e) {

          },
          async refresh(e, done) {
            const self: F7ComponentContextExtend = this;
            const currentState = $this.state['main'];
            let doneTimeout = null;
            if (done) {
              doneTimeout = setTimeout(() => {
                done();
              }, 10000);
            };

            let reportType = currentState.reportTypeList.find(f => f.id == currentState.reportForm.ReportType.getValue())?.reportType;
            let pages = [];
            const range = currentState.reportForm.Range.getValue();
            if (range && range.length < 2 || !reportType) {
              done && done();
              return;
            }
            const dateRange: Date[] = [range[0], range[1]];
            const branches = currentState.reportForm.Branches.getValue() as any[];
            const productGroups = currentState.reportForm.ProductGroups.getValue() as any[];
            const productCategories = currentState.reportForm.ProductCategories.getValue() as any[];
            const products = self.Products as any[];
            const employees = self.Employees as any[];
            const objects = self.Objects as any[];
            const extendProductsQuery = {
              ...(branches && branches.length > 0 ? { eq_Branch: `[${branches.join(',')}]` } : {}),
              ...(employees && employees.length > 0 ? { eq_Employee: `[${employees.join(',')}]` } : {}),
              ...(objects && objects.length > 0 ? { eq_Object: `[${objects.join(',')}]` } : {}),
              ...(productGroups && productGroups.length > 0 ? { eq_ProductGroup: `[${productGroups.join(',')}]` } : {}),
              ...(productCategories && productCategories.length > 0 ? { eq_ProductCategory: `[${productCategories.join(',')}]` } : {}),
              ...(products && products.length > 0 ? { eq_Product: `[${products.join(',')}]` } : {}),
            }

            let fromDate = dateRange && dateRange[0] && (new Date(dateRange[0].getFullYear(), dateRange[0].getMonth(), dateRange[0].getDate(), 0, 0, 0, 0)).toISOString() || null;
            let toDate = dateRange && dateRange[1] && new Date(dateRange[1].getFullYear(), dateRange[1].getMonth(), dateRange[1].getDate(), 23, 59, 59, 999).toISOString() || null;

            // Report summary
            let summaryReport = await $this.rootServices.apiService.getPromise<any[]>('/accounting/reports', {
              reportSummary: true,
              eq_Accounts: "511,512,515,521,632,635,642,641,623,131,331",
              skipHeader: true,
              branch: pages,
              toDate: toDate,
              fromDate: fromDate,
              limit: 'nolimit',
              ...extendProductsQuery
            });
            let summaryReportData: any = {
              Cash: 0,
              Revenues: 0,
              DecreaseRevenues: 0,
              DecreaseRevenuesByReturns: 0,
              DecreaseRevenuesByDiscount: 0,
              CustomerReceivableDebt: 0,
              CostOfGoodsSold: 0,
              GrossProfit: 0,
              NumOfVouchers: 0,
            };

            for (const reportItem of summaryReport) {
              // if (/^111/.test(reportItem.Account)) summaryReportData.Cash += (reportItem.GenerateDebit - reportItem.GenerateCredit);
              // if (/^112/.test(reportItem.Account)) summaryReportData.CashInBank += (reportItem.GenerateDebit - reportItem.GenerateCredit);
              if (/^511|512|515/.test(reportItem.Account)) {
                summaryReportData.Revenues += (reportItem.GenerateCredit - reportItem.GenerateDebit);
                summaryReportData.NumOfVouchers += reportItem.GenerateNumOfVouchers;
              }
              if (/^521/.test(reportItem.Account)) {
                summaryReportData.DecreaseRevenues += (reportItem.GenerateDebit - reportItem.GenerateCredit);
              }
              if (/^5212/.test(reportItem.Account)) {
                summaryReportData.DecreaseRevenuesByReturns += (reportItem.GenerateDebit - reportItem.GenerateCredit);
              }
              if (/^5213/.test(reportItem.Account)) {
                summaryReportData.DecreaseRevenuesByDiscount += (reportItem.GenerateDebit - reportItem.GenerateCredit);
              }
              if (/^632/.test(reportItem.Account)) {
                summaryReportData.CostOfGoodsSold += (reportItem.GenerateDebit - reportItem.GenerateCredit);
              }
              if (/^642|635|623|641/.test(reportItem.Account)) {
                summaryReportData.Cost += reportItem.GenerateDebit;
              }
              if (/^131/.test(reportItem.Account)) summaryReportData.CustomerReceivableDebt += reportItem.TailAmount;
            }

            self.$setState({
              // Summary data
              summaryReportData: {
                // Cash: $this.rootServices.currencyPipe.transform(summaryReportData.Cash, 'VND'),
                Revenues: $this.rootServices.currencyPipe.transform(summaryReportData.Revenues, 'VND'),
                NumOfVouchers: summaryReportData.NumOfVouchers,
                DecreaseRevenuesByReturns: $this.rootServices.currencyPipe.transform(summaryReportData.DecreaseRevenuesByReturns, 'VND'),
                DecreaseRevenuesByDiscount: $this.rootServices.currencyPipe.transform(summaryReportData.DecreaseRevenuesByDiscount, 'VND'),
                CostOfGoodsSold: $this.rootServices.currencyPipe.transform(summaryReportData.CostOfGoodsSold, 'VND'),
                CustomerReceivableDebt: $this.rootServices.currencyPipe.transform(summaryReportData.CustomerReceivableDebt, 'VND'),
                GrossProfit: $this.rootServices.currencyPipe.transform(summaryReportData.Revenues - summaryReportData.DecreaseRevenuesByReturns - summaryReportData.DecreaseRevenuesByDiscount - summaryReportData.CostOfGoodsSold, 'VND')
              },
            });



            /** Load data for sales activetity */
            let revenueStatistics = await $this.rootServices.apiService.getPromise<any[]>('/accounting/statistics', { eq_Account: "[511,512,515,5213,5212]", statisticsRevenue: true, branch: pages, reportBy: reportType, ge_VoucherDate: fromDate, le_VoucherDate: toDate, limit: 'nolimit', ...extendProductsQuery });
            let costStatistics632 = await $this.rootServices.apiService.getPromise<any[]>('/accounting/statistics', { eq_Account: "[632]", statisticsCost: true, branch: pages, reportBy: reportType, ge_VoucherDate: fromDate, le_VoucherDate: toDate, limit: 'nolimit', ...extendProductsQuery });

            /** Prepare data */
            let line1Data = revenueStatistics.map(statistic => { statistic.Label = $this.makeStaticLabel(statistic, reportType); statistic.Timeline = $this.makeTimeline(statistic, reportType); statistic.Value = statistic.SumOfCredit - statistic.SumOfDebit; return statistic; });
            let line2Data = costStatistics632.map(statistic => { statistic.Label = $this.makeStaticLabel(statistic, reportType); statistic.Timeline = $this.makeTimeline(statistic, reportType); statistic.Value = statistic.SumOfDebit - statistic.SumOfCredit; return statistic; });
            // let line3Data = costStatistics641.map(statistic => { statistic.Label = $this.makeStaticLabel(statistic, reportType); statistic.Timeline = $this.makeTimeline(statistic, reportType); statistic.Value = statistic.SumOfDebit - statistic.SumOfCredit; return statistic; });
            let timeline = [...new Set([
              ...line1Data.map(item => item['Timeline']),
              ...line2Data.map(item => item['Timeline']),
              // ...line3Data.map(item => item['Timeline']),
            ].sort())];

            let labels = [];
            let mergeData: any;

            mergeData = timeline.map(t => {
              const point1 = line1Data.find(f => f.Timeline == t);
              const point2 = line2Data.find(f => f.Timeline == t);
              // const point3 = line3Data.find(f => f.Timeline == t);
              labels.push(point1?.Label || point2?.Label);
              // labels.push(point1?.Label);
              return {
                Label: t,
                Line1: point1 || { Value: 0 },
                Line2: point2 || { Value: 0 },
                // Line3: point3 || { Value: 0 },
              };
            });

            self.costAndRevenueStatisticsData = {
              labels: labels,
              datasets: [
                {
                  label: 'Doanh thu',
                  data: mergeData.map(point => point.Line1['Value']),
                  borderColor: $this.rootServices.themeColors.default.succuess,
                  backgroundColor: $this.rootServices.themeColors.default.succuess,
                  pointRadius: 1,
                  pointHoverRadius: 1,
                },
                {
                  label: 'Giá vốn',
                  data: mergeData.map(point => point.Line2['Value']),
                  borderColor: $this.rootServices.themeColors.default.danger,
                  backgroundColor: $this.rootServices.themeColors.default.danger,
                  pointRadius: 1,
                  pointHoverRadius: 1,
                },
              ],
            };

            if (!self.salesActivityChart) {
              self.salesActivityChart = self.salesActivityChart || new Chart('salesActivityChart', {
                type: 'bar',
                data: self.costAndRevenueStatisticsData as any,
                options: {
                  scales: {
                    // y: {
                    //   beginAtZero: true
                    // }
                  }
                }
              });
            } else {
              self.salesActivityChart.data = self.costAndRevenueStatisticsData;
              self.salesActivityChart.update('active');
            }
            // End

            /** Load data for numOfVouchersChart */
            revenueStatistics = await $this.rootServices.apiService.getPromise<any[]>('/accounting/statistics', { eq_Account: "[511,512,515]", statisticsRevenue: true, branch: pages, reportBy: reportType, ge_VoucherDate: fromDate, le_VoucherDate: toDate, limit: 'nolimit', ...extendProductsQuery });
            let numOfVouchersLineData = revenueStatistics.map(statistic => { statistic.Label = $this.makeStaticLabel(statistic, reportType); statistic.Timeline = $this.makeTimeline(statistic, reportType); statistic.Value = statistic.NumOfVouchers; return statistic; });

            labels = [];
            mergeData = timeline.map(t => {
              const point1 = numOfVouchersLineData.find(f => f.Timeline == t);
              labels.push(point1?.Label);
              return {
                Label: t,
                Line1: point1 || { Value: 0 },
              };
            });

            self.numOfVouchersStatisticsData = {
              labels: labels,
              datasets: [
                {
                  label: 'Lượt khách',
                  data: mergeData.map(point => point.Line1['Value']),
                  borderColor: $this.rootServices.themeColors.default.succuess,
                  backgroundColor: $this.rootServices.themeColors.default.succuess,
                  pointRadius: 1,
                  pointHoverRadius: 1,
                  fill: true,
                },
              ],
            };

            if (!self.salesNumOfVouchersChart) {
              self.salesNumOfVouchersChart = self.salesNumOfVouchersChart || new Chart('salesNumOfVouchersChart', {
                type: 'bar',
                data: self.numOfVouchersStatisticsData as any,
                options: {
                  scales: {
                    // y: {
                    //   beginAtZero: true
                    // }
                  }
                }
              });
            } else {
              self.salesNumOfVouchersChart.data = self.numOfVouchersStatisticsData;
              self.salesNumOfVouchersChart.update('active');
            }
            // End

            // Load statistic data for debt
            /** Load data */
            let debtStatistics = await $this.rootServices.apiService.getPromise<any[]>('/accounting/statistics', { eq_Account: "[131]", increment: true, branch: pages, reportBy: reportType, ge_VoucherDate: fromDate, le_VoucherDate: toDate, limit: 'nolimit', ...extendProductsQuery });

            /** Prepare data */
            line1Data = debtStatistics.map(statistic => { statistic.Label = $this.makeStaticLabel(statistic, reportType); statistic.Timeline = $this.makeTimeline(statistic, reportType); statistic.Value = statistic.SumOfDebit - statistic.SumOfCredit; return statistic; });
            // let line2Data = costStatistics632.map(statistic => { statistic.Label = $this.makeStaticLabel(statistic, reportType); statistic.Timeline = $this.makeTimeline(statistic, reportType); statistic.Value = statistic.SumOfDebit - statistic.SumOfCredit; return statistic; });
            // let line3Data = costStatistics641.map(statistic => { statistic.Label = $this.makeStaticLabel(statistic, reportType); statistic.Timeline = $this.makeTimeline(statistic, reportType); statistic.Value = statistic.SumOfDebit - statistic.SumOfCredit; return statistic; });
            timeline = [...new Set([
              ...line1Data.map(item => item['Timeline']),
              // ...line2Data.map(item => item['Timeline']),
              // ...line3Data.map(item => item['Timeline']),
            ].sort())];

            labels = [];

            mergeData = timeline.map(t => {
              const point1 = line1Data.find(f => f.Timeline == t);
              // const point2 = line2Data.find(f => f.Timeline == t);
              // const point3 = line3Data.find(f => f.Timeline == t);
              // labels.push(point1?.Label || point2?.Label);
              labels.push(point1?.Label);
              return {
                Label: t,
                Line1: point1 || { Value: 0 },
                // Line2: point2 || { Value: 0 },
                // Line3: point3 || { Value: 0 },
              };
            });

            self.debtStatisticsData = {
              labels: labels,
              datasets: [
                {
                  label: 'Công nợ',
                  data: mergeData.map(point => point.Line1['Value']),
                  borderColor: $this.rootServices.themeColors.default.danger,
                  backgroundColor: $this.rootServices.themeColors.dim10.danger,
                  pointRadius: 1,
                  pointHoverRadius: 1,
                },
              ],
            };

            if (!self.salesDebtChart) {
              self.salesDebtChart = self.salesDebtChart || new Chart('salesDebtChart', {
                type: 'line',
                data: self.debtStatisticsData as any,
                options: {
                  scales: {
                    // y: {
                    //   beginAtZero: true
                    // }
                  }
                }
              });
            } else {
              self.salesDebtChart.data = self.debtStatisticsData;
              self.salesDebtChart.update('active');
            }

            // Report top
            let topEmployeeList = [];
            let topCustomerList = [];
            let topGoodsList = [];
            await $this.rootServices.apiService.getPromise<any>('/accounting/reports', { reportNetRevenusFromEmployee: true, branch: pages, fromDate: fromDate, toDate: toDate, sort_CreditGenerate: 'desc', limit: 100, ...extendProductsQuery }).then(rs => {
              topEmployeeList = rs.map(item => {
                item.Revenus = $this.rootServices.currencyPipe.transform((item.GenerateCredit - item.GenerateDebit) || 0, 'VND');
                return item;
              });
              console.log(rs);
            });
            await $this.rootServices.apiService.getPromise<any>('/accounting/reports', { reportNetRevenusFromCustomer: true, branch: pages, fromDate: fromDate, toDate: toDate, sort_CreditGenerate: 'desc', limit: 100, ...extendProductsQuery }).then(rs => {
              topCustomerList = rs.map(item => {
                item.Revenus = $this.rootServices.currencyPipe.transform((item.GenerateCredit - item.GenerateDebit) || 0, 'VND');
                return item;
              });
              console.log(rs);
            });
            await $this.rootServices.apiService.getPromise<any>('/accounting/reports', { reportNetRevenusFromGoods: true, branch: pages, fromDate: fromDate, toDate: toDate, sort_CreditGenerate: 'desc', limit: 100, ...extendProductsQuery }).then(rs => {
              topGoodsList = rs.map(item => {
                item.Revenus = $this.rootServices.currencyPipe.transform((item.GenerateCredit - item.GenerateDebit) || 0, 'VND');
                return item;
              });
              console.log(rs);
            });

            self.$setState({
              // Summary data
              // summaryReportData: {
              //   Cash: $this.rootServices.currencyPipe.transform(summaryReportData.Cash, 'VND'),
              //   Revenues: $this.rootServices.currencyPipe.transform(summaryReportData.Revenues, 'VND'),
              //   DecreaseRevenuesByReturns: $this.rootServices.currencyPipe.transform(summaryReportData.DecreaseRevenuesByReturns, 'VND'),
              //   DecreaseRevenuesByDiscount: $this.rootServices.currencyPipe.transform(summaryReportData.DecreaseRevenuesByDiscount, 'VND'),
              //   CustomerReceivableDebt: $this.rootServices.currencyPipe.transform(summaryReportData.CustomerReceivableDebt, 'VND'),
              // },
              // Top data
              topEmployeeList: topEmployeeList,
              topCustomerList: topCustomerList,
              topGoodsList: topGoodsList,
            });
            done && done();
            return true;
          },
        },
        on: {
          // pageMounted(e, page) {
          //     console.log('page mounted');
          // },
          pageInit(e, page: F7Page) {
            console.log('page init');
            const self: F7ComponentContextExtend = this;
            // Loading flag
            let allowInfinite = true;
            $this.onComponentInit({ instance: self }, 'main', null, page).then(currentState => {
              // self.refresh();
            });

          },
          // pageBeforeIn(e, page) {
          //     console.log('page before in');
          //     const self: F7ComponentContextExtend = this;
          //     self.refresh();
          // },
          pageAfterIn(e, page) {
            console.log('page after in');
            const self: F7ComponentContextExtend = this;
            const currentState = $this.state[self.$route.params.id];
            if (e['detail']?.from == 'previous') {
              self.refresh();
            }
          },
          // pageBeforeOut(e, page) {
          //     console.log('page before out');
          // },
          // pageAfterOut(e, page) {
          //     console.log('page after out');
          // },
          // pageBeforeUnmount(e, page) {
          //     console.log('page before unmount');
          // },
          // pageBeforeRemove(e, page) {
          //     console.log('page before remove');
          // },
          pageBeforeRemove(e, page) {
            console.log('[page event] before remove', page.route.url);
            const self: F7ComponentContextExtend = this;
            // const starmtSelectRoles = self.$app.smartSelect.get('.smart-select');
            // starmtSelectRoles.destroy();
          },
        },
      },
    };
  }
}
